<template>
    <div class="mitem focus-s" :class="{'mlearn-end': bookUnit.learnCount >= bookUnit.wordCount,'mlearn-ing': bookUnit.learnCount > 0, 'msel': selected }">
        <div>
            <div class="msp">
                <div class="vc-flex">
                    <div class="seqno" :class="{'learn-end': bookUnit.learnCount >= bookUnit.wordCount,'learn-ing': bookUnit.learnCount > 0}">{{ seqNo }}</div>
                    <div class="lbname" :class="{ 'lbsel': selected }">{{ bookUnit.unitName }}</div>
                </div>
                <div>
                    <i class="fa fa-play-circle vplay" v-if="selected"></i>
                    <i class="fa fa-lock mlock" v-else></i>

                </div>
            </div>
            <div class="smx">
                <span>{{bookUnit.wordCount}}</span>
                <span class="vsplit">/</span>
                <span>{{bookUnit.learnCount}}</span>
                <span class="vsplit">/</span>
                <span>{{bookUnit.masterCount}}</span>
            </div>
        </div>
        <div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'BookUnitItem',
    props: {
        bookUnit: Object,
        selected: {
            type: Boolean,
            default: false
        },
        seqNo: {
            type: Number,
            default: 0
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lbname{
    
}
.vsplit{
    color: var(--ek-text-color3);
    margin-left: 4px;
    margin-right: 4px;
}
.mlock{
    color: var(--ek-text-color3);
}
.vplay{
    color: #558bfd;
}
.msp {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.smx {
    font-size: 12px;
    margin-top: 7px;
    padding-left: 5px;
}

.mitem {
    display: flex;
    flex-direction: column;
    height: 70px;
    justify-content: center;
    margin-left: 15px;
    margin-right: 15px;
    color: var(--ek-text-color2);
    background: var(--ek-card-color1);
    margin-bottom: 10px;
    border-radius: 10px;
    border-left: 5px solid var(--ek-card-progress-bgColor);
    padding-left: 10px;
    padding-right: 10px;
}

.seqno {
    width: 25px;
    height: 25px;
    background: var(--ek-card-progress-bgColor);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    margin-right: 10px;
    font-size: 11px;
    color: var(--ek-text-color2);
}
.learn-ing{
    background-color: rgb(59 130 246)!important;
    color: white!important;
    
}
.mlearn-ing{
    border-color: rgb(59 130 246) !important;
}

.learn-end{
    background-color: rgb(16 185 129)!important;
    color: white!important;
    border-color: rgb(16 185 129) !important;
}
.mlearn-end{

    border-color: rgb(16 185 129) !important;
}

.msel {
    background-color: rgb(59 130 246 / 0.05) !important;
    border-color: #558bfd !important;
}

.lblearnprog {
    font-size: 14px;
    color: var(--ek-text-color2);
}

.sflag {
    width: 5px;
    height: 15px;

    margin-right: 5px;
}

.sfsel {
    background: #515cff;
}

.lbsel {
    color: var(--ek-text-color1);
}
</style>
